import { render, staticRenderFns } from "./Recycle.vue?vue&type=template&id=f11dfd64&scoped=true&"
import script from "./Recycle.vue?vue&type=script&lang=js&"
export * from "./Recycle.vue?vue&type=script&lang=js&"
import style0 from "./Recycle.vue?vue&type=style&index=0&id=f11dfd64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11dfd64",
  null
  
)

export default component.exports